// @flow

/* eslint-disable new-cap */
import { get } from 'lodash';
import {
  FETCH_BOOKING_STAY_FORMALITIES,
  FETCH_BOOKING_STAY_FORMALITIES_RESOLVED,
  FETCH_BOOKING_STAY_FORMALITIES_REJECTED,
  CLEAR_BOOKING_STAY_FORMALITIES,
} from 'Store/member-space/booking/booking.constants';

import createReducer from 'Store/utils/createReducer';

const initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null,
};

export default createReducer(initialState, {
  [FETCH_BOOKING_STAY_FORMALITIES](state: ReduxState): ReduxState {
    return {
      ...state,
      isLoading: true,
    };
  },
  [FETCH_BOOKING_STAY_FORMALITIES_RESOLVED](state: ReduxState, action): ReduxState {
    return {
      ...state,
      data: get(action, 'payload.userBooking.stayFormalities') || [],
      isLoaded: true,
      isLoading: false,
    };
  },
  [FETCH_BOOKING_STAY_FORMALITIES_REJECTED](state: ReduxState, action): ReduxState {
    return {
      ...state,
      isLoading: false,
      isLoaded: true,
      isOnError: true,
      errorResponse: { errors: action.payload.errors },
    };
  },
  [CLEAR_BOOKING_STAY_FORMALITIES](): ReduxState {
    return initialState;
  },
});
